<div>
  <div class="search-bar">
    <mat-form-field appearance="outline" class="input-search">
      <mat-label>{{ 'pages.movements_list.search' | translate }}</mat-label>
      <input [formControl]="search" autocomplete="off" matInput spellcheck="false" />
      <mat-hint>
        {{ 'pages.movements_list.search_by_name' | translate }}
      </mat-hint>
    </mat-form-field>
  </div>
  <div class="estado" *ngIf="showOptions">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'pages.movements_list.state' | translate }}</mat-label>
      <mat-select
        #estadoMatSelect
        [(value)]="estadoPagoSelect"
        (selectionChange)="selectionChangeEstado()"
        name="estadoPago"
        multiple
      >
        <mat-option *ngFor="let estado of estadoDelPago" [value]="estado.value">
          {{ estado.display }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>{{ 'pages.movements_list.date_from' | translate }}</mat-label>
      <div (click)="matDateToggleTo.datepicker.open()">
        <input
          style="cursor: pointer !important"
          #fechaDesde
          matInput
          [matDatepicker]="picker"
          (dateInput)="fechaDesdePicker($event)"
          [placeholder]="translate('pages.payment-link.labels.date')"
          disabled
          readonly
        />
      </div>
      <mat-datepicker-toggle #matDateToggleTo matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker disabled="false"></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'pages.movements_list.method' | translate }}</mat-label>

      <mat-select
        #medioPagoMatSelect
        [(value)]="paymentMethodSelect"
        (selectionChange)="selectionChangeMethod()"
        name="paymentMethod"
        multiple
      >
        <mat-option *ngFor="let paymentMethod of paymentMethodCollection" [value]="paymentMethod.value">
          {{ paymentMethod.display }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>{{ 'pages.movements_list.date_to' | translate }}</mat-label>
      <div (click)="matDateToggleFrom.datepicker.open()">
        <input
          #fechaHasta
          style="cursor: pointer !important"
          matInput
          [min]="minDate"
          [matDatepicker]="picker1"
          (dateInput)="fechaHastaPicker($event)"
          [placeholder]="translate('pages.payment-link.labels.date')"
          disabled
          readonly
        />
      </div>
      <mat-datepicker-toggle #matDateToggleFrom matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1 [disabled]="disabledPicker"></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="commerceUser || userResponsible">
      <mat-label>{{ 'pages.movements_list.branch' | translate }}</mat-label>
      <mat-select #branchMatSelect [(value)]="branchOfficeSelect" (selectionChange)="selectionChangeBranch()" multiple>
        <mat-option>
          <ngx-mat-select-search
            [formControl]="searchBranch"
            placeholderLabel="Buscar sucursal"
            noEntriesFoundLabel="No se encontró sucursal"
          >
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let branchOffice of branchFilter" [value]="branchOffice.value">
          {{ branchOffice.display }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="commerceUser || userResponsible">
      <mat-label>{{ 'pages.movements_list.cashier' | translate }}</mat-label>
      <mat-select #cashierMatSelect [(value)]="cashierSelect" (selectionChange)="selectionChangeCashier()" multiple>
        <mat-option>
          <ngx-mat-select-search
            [formControl]="searchCashier"
            placeholderLabel="Buscar caja"
            noEntriesFoundLabel="No se encontró una caja"
          >
          </ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let cashier of cashierFilter" [value]="cashier.value">
          {{ cashier.display }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div>
      <button
        mat-icon-button
        style="color: #afafaf"
        (click)="ngOnInit()"
        data-toggle="tooltip"
        data-placement="bottom"
        title="Actualizar movimientos"
      >
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
    <button
      mat-icon-button
      (click)="excelExport()"
      style="color: #afafaf"
      data-toggle="tooltip"
      data-placement="bottom"
      title="Descargar movimientos"
    >
      <mat-icon>download</mat-icon>
    </button>
  </div>
  <div style="width: 100%">
    <div class="buttons-filters" *ngIf="showOptions">
      <button mat-raised-button (click)="filtroGeneralV2()" color="primary">
        {{ 'pages.movements_list.buttons.filter' | translate }}
      </button>
      <button mat-raised-button (click)="cleanFiltersV2()" color="warn" [disabled]="stateButtonClean()">
        {{ 'pages.movements_list.buttons.clean_filters' | translate }}
      </button>
    </div>
    <div>
      <button mat-stroked-button style="width: 100%" color="primary" (click)="showOptions = !showOptions">
        {{ showOptions ? 'Ocultar filtros' : 'Mostrar filtros' }}
      </button>
    </div>
  </div>
  <div style="margin-top: 20px; overflow-y: auto">
    <div *ngIf="noMovements">
      <span>{{ 'pages.movements_list.no_movements' | translate }}</span>
    </div>
    <div
      class="movement-card-container"
      *ngFor="
        let element of filterMovs | paginate : { itemsPerPage: 10, currentPage: pageActual, totalItems: totalSize }
      "
      (click)="clickInAction(element, { id: 1, name: 'pageview', path: 'detail-pay', status: true, type: 'action' })"
    >
      <div class="container-cuit-cvu-titulo">
        <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
          <span data-toggle="tooltip" data-placement="bottom" title="Nº de operación">
            {{ (element.tipoMovimiento === 'IncomingTransaction' ? element.id : element.referencia) + ' | ' }}
          </span>
          <span
            style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap"
            [innerHTML]="element.titulo"
          ></span>
        </div>
        <span class="cuit-cvu"
          >CUIT:
          {{
            element.cuilCuitContraparte
              ? maskCuit(element.cuilCuitContraparte)
              : 'No
                    especificado'
          }}</span
        >
        <span class="cuit-cvu"
          >CVU :
          {{
            element.cvuContraparte
              ? element.cvuContraparte
              : 'No
                    especificado'
          }}</span
        >
        <span class="cuit-cvu"
          >{{ element.debinId?.length === 22 ? 'Debin ID: ' : '' }}
          {{ element.debinId?.length === 22 ? element.debinId : '' }}</span
        >
      </div>

      <div class="container-importe-estado-hora">
        <div class="importe-estado">
          <span>{{ maskPrice(element.importe) }}</span>
          <span [ngClass]="setClassEstado(element.estado)">{{ element.estado }}</span>
        </div>

        <div class="medio-icon">
          <img alt="" [src]="getIcon(element).iconURL" height="30px" />
        </div>

        <div class="fecha-hora">
          <span style="font-weight: bold">{{ element.fecha | date : 'd/M/yy' }}</span>
          <span>{{ element.fecha | date : 'H:mm' }} h</span>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="loading" style="width: 100%; display: flex; justify-content: center">
    <img style="border-radius: 57px" src="assets/icons/logo-fiser-loading.gif" alt="" width="150px" />
  </div>
</div>
<pagination-controls
  *ngIf="filterMovs.length > 0"
  class="my-pagination"
  responsive="true"
  maxSize="7"
  previousLabel=""
  nextLabel=""
  (pageChange)="pageActual = $event; nextPage()"
>
</pagination-controls>
